import React from 'react';
import {
  Formik,
  Field,
} from 'formik';
import {
  Flex,
} from 'web-styled';
import {
  Modal,
  Button,
  TextField,
} from 'web-components';

type Props = {
  isOpen: boolean;
  onSubmit: { (data: any, actions: any): void };
  onRequestClose: { (): void };
};

const AddFolder = ({ isOpen, onSubmit, onRequestClose }: Props) => (
  <Modal
    title="Add Folder"
    isOpen={isOpen}
    onRequestClose={onRequestClose}
  >
    <Formik
      initialValues={{
        name: '',
      }}
      onSubmit={onSubmit}
    >
      {({
        handleSubmit,
        isSubmitting,
      }) => (
        <Flex
          column
          as="form"
          width="100%"
          spacing={15}
          onSubmit={handleSubmit}
        >
          <Field
            autoFocus
            name="name"
            label="Enter name"
            component={TextField}
          />
          <Flex width="100%" justify="flex-end">
            <Button
              ghost
              appearance="primary"
              type="submit"
              spacing="large"
              isLoading={isSubmitting}
              isDisabled={isSubmitting}
            >
              Add Folder
            </Button>
          </Flex>
        </Flex>
      )}
    </Formik>
  </Modal>
);

export default AddFolder;
